import { render, staticRenderFns } from "./LogoDark.vue?vue&type=template&id=643f946c&scoped=true"
import script from "./LogoDark.vue?vue&type=script&lang=js"
export * from "./LogoDark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f946c",
  null
  
)

export default component.exports